namespace RedBullMOBILE360.Administration {
    export namespace PermissionKeys {
        export const Security = "Administration:Security";
        export const Translation = "Administration:Translation";
    }
}
